import { useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import TechnicalSpecForm, {
  type TechnicalSpecFormData,
} from "./TechnicalSpecForm";
import { toast } from "sonner";
import { trpcClient } from "@/lib/trpc";
import { useQueryClient } from "@tanstack/react-query";

export default function TechnicalSpecCreate() {
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const handleSubmit = async (data: TechnicalSpecFormData) => {
    try {
      await trpcClient.technical.specs.create.mutate(data as any);

      queryClient.invalidateQueries({ queryKey: ["technical-specs"] });
      navigate({ to: "/specs" as any });
    } catch (error: any) {
      toast.error(error?.message || "Thêm QTCN thất bại");
    }
  };

  return (
    <div className="w-full space-y-4 p-4 animate-in fade-in duration-300">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate({ to: "/specs" as any })}
        >
          <ArrowLeft size={18} />
        </Button>
      </div>
      <TechnicalSpecForm
        onSubmit={handleSubmit}
        onCancel={() => navigate({ to: "/specs" as any })}
        submitLabel="Tạo mới"
      />
    </div>
  );
}
